import { nest } from 'd3';

const nonOriginColumns = {
  'Total': true,
  'Segment': true,
  'Category': true,

  // The following are origins,
  // but are excluded as per Dan's request.
  'NVM-Br-Fr': true,
  'NVM-Eur': true,
  'NVM-Other': true,
  'Total VM': true
};

// Determines whether or not a given column should be
// treated as an origin and included in the visualization.
const isOriginColumn = column => !nonOriginColumns[column];

// Parse all columns except 'Segment' as numbers.
// Melt the data so the columns become rows.
export const transformData = (rawData, filterBy) => {
  // This row contains total populations across other categories.
  const totals = rawData.filter(d => (d.Category === 'Number' && d.Segment === filterBy))[0];
  // Compute the origins, which will become
  // values in a new column 'origin';
  const origins = rawData.columns.filter(isOriginColumn);

  // Melt the data so rows become column values.
  const data = [];
  rawData
    .filter(d => d.Category !== 'Number')
    .forEach(d => {

      console.log(rawData);


      origins.forEach(origin => {
        data.push({
          origin,
          segment: d.Segment,
          category: d.Category,
          value: +d[origin],
          total: +totals[origin] // Copy the total into new rows.
        });
      });
    });

  // The visualization shows data for a single segment at a time.
  // Desired future feature described by Dan:
  // interactively switch between 'Total population' and 'Im 2011-15'.
  return data
    .filter(d => d.segment === filterBy);
};



// WEBPACK FOOTER //
// ./src/MetropolitanBubbleChart/transformData.js